var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05517 4.15349C3.51045 4.46853 3.3247 5.16473 3.64029 5.7085L5.58009 9.05086C2.522 10.9733 0.389273 14.2286 0 18H24C23.6105 14.2266 21.4757 10.9698 18.415 9.04778L20.353 5.7085C20.6686 5.16473 20.4829 4.46853 19.9381 4.15349C19.3934 3.83846 18.696 4.02388 18.3804 4.56765L16.3754 8.02241C15.0189 7.49521 13.5433 7.20593 12 7.20593C10.4546 7.20593 8.97714 7.49598 7.61917 8.02453L5.6129 4.56765C5.29731 4.02388 4.59989 3.83846 4.05517 4.15349Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79566 14.7187C6.29392 15.0253 7.00546 14.7757 7.38491 14.1612C7.76436 13.5467 7.66804 12.8 7.16978 12.4934C6.67151 12.1868 5.95997 12.4364 5.58052 13.0509C5.20107 13.6654 5.29739 14.4121 5.79566 14.7187Z",
    fill: "#202124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2102 14.7187C17.7119 15.0253 17.0004 14.7757 16.621 14.1612C16.2415 13.5467 16.3378 12.8 16.8361 12.4934C17.3344 12.1868 18.0459 12.4364 18.4253 13.0509C18.8048 13.6654 18.7085 14.4121 18.2102 14.7187Z",
    fill: "#202124"
  })));
};
export default SvgAndroid;